import { useEffect, useState } from "react";
import { useApi } from "utils";
import { TotalUnit, ValueStockType } from "../../types";

type ParamsType = {
    date: string;
    location_id: string;
};


// Tipe data gabungan untuk semua API
interface APIResponseType {
    valueStock: ValueStockType | null;
    totalUnit: TotalUnit | null;
}

// List API yang di-fetch
const endpoints = [
    { key: "totalUnit", url: "/dasboard_inventory/inbound_outbound" },
    { key: "valueStock", url: "/dasboard_inventory/soh_perlocation/" }
] as const;

export function useList({ date, location_id }: ParamsType) {
    const api = useApi();
    const [data, setData] = useState<APIResponseType>({
        valueStock: null,
        totalUnit: null
    });
    const [loading, setLoading] = useState<boolean>(true);

    const params: Record<string, string | number> = { year_month: date };
    if (location_id) params.location_id = location_id;

    const fetchData = async () => {
        setLoading(true);
        try {
            const responses = await Promise.all(
                endpoints.map(async ({ key, url }) => {
                    try {
                        const res = await api.get(url, { params });
                        return { key, payload: res.data.payload };
                    } catch {
                        return { key, payload: null };
                    }
                })
            );

            const newData = responses.reduce((acc, { key, payload }) => {
                acc[key as keyof APIResponseType] = payload;
                return acc;
            }, {} as APIResponseType);

            setData(newData);
        } catch (error) {
            setData({
                valueStock: null,
                totalUnit: null
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        return () => setData({
            valueStock: null,
            totalUnit: null
        });
        // eslint-disable-next-line
    }, [date, location_id]);

    return { fetchData, data, loading };
}
